import React, {Component} from 'react';

class Help extends Component {
  render() {
    return (
      <div>
        Help page
      </div>
    );
  }
}

export default Help;